import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client.js";

export interface Repo {
  id: string;
  slug: string;
  description: string | null;
  defaultBranch: string;
  createdAt: string;
}

export interface CreateRepoInput {
  slug: string;
  description?: string;
  defaultBranch?: string;
}

export const reposQueryKey = (slug: string) => ["repos", slug] as const;

export function useRepos(slug: string) {
  return useQuery({
    queryKey: reposQueryKey(slug),
    queryFn: async () => apiFetch<{ repos: Repo[] }>(`/api/ws/${encodeURIComponent(slug)}/repos`),
    enabled: slug.length > 0,
  });
}

export function useCreateRepo(slug: string) {
  const qc = useQueryClient();
  return useMutation<Repo, ApiError, CreateRepoInput>({
    mutationFn: async (input) => {
      const { repo } = await apiFetch<{ repo: Repo }>(`/api/ws/${encodeURIComponent(slug)}/repos`, {
        method: "POST",
        body: input,
      });
      return repo;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: reposQueryKey(slug) });
    },
  });
}
